import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import './login.scss';
import adminApi from 'services/adminApi';

export default function Login() {
  const [form, setForm] = useState({
    email: { value: '', error: '' },
    password: { value: '', error: '' },
  });

  const history = useHistory();

  const handleLogin = async (e) => {
    e.preventDefault();

    const newForm = {
      email: {
        ...form.email,
        error: form.email.value.includes(' ')
          ? 'Username must not contain spaces.'
          : '',
      },
      password: {
        ...form.password,
        error: form.password.value.includes(' ')
          ? 'Password must not contain spaces.'
          : '',
      },
    };

    setForm(newForm);

    if (newForm.email.error || newForm.password.error) return;

    const res = await adminApi({
      url: `/auth/login`,
      method: 'POST',
      body: { email: form.email.value, password: form.password.value },
    });

    const { isSuccess, data } = await res.json();

    if (!isSuccess) {
      alert('User or Password is incorrect');
      return;
    }

    localStorage.setItem('userId', data.userId);
    localStorage.setItem('token', data.token);
    history.push('/admin');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Cập nhật giá trị và kiểm tra lỗi
    setForm((prevForm) => ({
      ...prevForm,
      [name]: {
        value,
        error:
          value.trim() === ''
            ? `${
                name === 'email' ? 'Username' : 'Password'
              } must not contain spaces.`
            : value.includes(' ')
            ? `${
                name === 'email' ? 'Username' : 'Password'
              } must not contain spaces.`
            : '',
      },
    }));
  };

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');
    if (userId && token) history.push('/admin');
    // eslint-disable-next-line
  }, []);

  const isLoginDisabled =
    !form.email.value.trim() ||
    !form.password.value.trim() ||
    form.email.error ||
    form.password.error;

  return (
    <div className="admin-login c-app flex-row align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header bg-primary text-white text-center">
                <h3>VNNIC</h3>
              </div>
              <div className="card-body">
                <form onSubmit={handleLogin}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Username
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        form.email.error ? 'is-invalid' : ''
                      }`}
                      id="email"
                      name="email"
                      placeholder="Enter your username"
                      value={form.email.value}
                      onChange={handleChange}
                    />
                    {form.email.error && (
                      <div className="invalid-feedback">{form.email.error}</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className={`form-control ${
                        form.password.error ? 'is-invalid' : ''
                      }`}
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      value={form.password.value}
                      onChange={handleChange}
                    />
                    {form.password.error && (
                      <div className="invalid-feedback">
                        {form.password.error}
                      </div>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isLoginDisabled}
                  >
                    Login
                  </button>
                </form>
              </div>
              <div className="card-footer text-center" hidden>
                {/* // eslint-disable-next-line */}
                {/* <button className="text-decoration-none">
                  Forgot your password?
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
